import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { useLayout3Theme } from './theme';
import './styles.css';

interface Layout3RootProps {
  children: ReactNode;
  className?: string;
  withHeader?: boolean;
}

export function Layout3Root({ children, className, withHeader }: Layout3RootProps) {
  const { themeStyle } = useLayout3Theme();

  return (
    <div
      className={cn(
        'layout-3 min-h-screen bg-[var(--wl3-bg)]',
        withHeader && 'layout-3-with-header',
        className
      )}
      style={themeStyle}
    >
      {children}
    </div>
  );
}
